import { Build, Job } from "~/components/build/Show/lib/types";
import fetcher from "~/components/build/Show/lib/fetcher";
import { queryOptions, UseQueryOptions } from "@tanstack/react-query";

export function nextJobFailureQueryKey(
  buildId: Build["id"],
  jobId: Job["id"],
  buildJobFailuresCount: number,
) {
  return ["build", buildId, "next-failure", jobId, { buildJobFailuresCount }];
}

export function nextJobFailureQueryOptions(
  build: Build,
  jobId: Job["id"],
  queryOptionArgs: Omit<UseQueryOptions<Job["id"] | null>, "queryKey" | "queryFn" | "enabled"> = {},
) {
  const jobsFailedCount = build.statistics?.jobsFailedCount || 0;

  return queryOptions({
    queryKey: nextJobFailureQueryKey(build.id, jobId, jobsFailedCount),
    queryFn: ({ client, signal }) =>
      fetchNextJobFailure(build, jobId, signal).then((jobIds) => {
        for (let index = 0; index < jobIds.length; index++) {
          const jobId = jobIds[index];
          const nextJobId = jobIds[index + 1];
          if (jobId && nextJobId) {
            client.setQueryData(
              nextJobFailureQueryKey(build.id, jobId, jobsFailedCount),
              nextJobId,
            );
          }
        }
        return jobIds[0] ?? null;
      }),
    enabled: Features.ProgressiveBuildShow && Boolean(jobId) && jobsFailedCount > 0,
    ...queryOptionArgs,
  });
}

async function fetchNextJobFailure(
  build: Build,
  jobId: Job["id"],
  signal: AbortSignal,
): Promise<Job["id"][]> {
  const url = `${build.buildDataBasePath}/next-failure/${jobId}`;

  // We don't want to use the Database.parser method here as it will camelize stepUUID keys.
  return fetcher<Array<Job["id"]>>(url, false, { signal });
}
